import * as actions from './auth.actions';
import * as selectors from './auth.selectors';
import { reducer, authFeatureKey } from './auth.reducer';
import { AuthEffects } from './auth.effects';
export * from './auth.config';

// The object that groups all things related to AuthStore
export const AuthStore = {
  actions,
  selectors,
  reducer,
  effects: [AuthEffects],
  config: { name: authFeatureKey, reducer },
};
